module.exports = __webpack_public_path__ + "img/Konstruktion.c029b4bb.jpg";